module.exports = __webpack_public_path__ + "static/media/BLUSH_3872.70b1cdbb.jpg";